import { PaymentCardImageTypes } from '@mews/framework/payments';
import { PaymentMethodImageType } from './types';

export const getSourceImageByType = (type: PaymentMethodImageType | keyof PaymentCardImageTypes) => `${type}.svg`;
